var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"dense":"","loading":_vm.loading,"loading-text":_vm.$t('wgu-attributetable.loadingText'),"headers":_vm.disasterHeaders,"items":_vm.disastersList,"mobile-breakpoint":"0","page":_vm.page,"footer-props":{
      'items-per-page-options': [_vm.rowsPerPage],
      'show-first-last-page': true
    },"single-select":"","value":_vm.selectedRow,"item-key":_vm.uniqueRecordKeyName,"items-per-page":_vm.rowsPerPage,"height":_vm.getTableHeight()},on:{"update:page":function($event){_vm.page=$event},"click:row":_vm.onRowClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }